import o from"../colors/index.js";var r={bgColor:o.white,borderRadius:"0.4rem",shadowColor:o.grey[400]};export{r as default};
